export const IMAGE_SIZE_LIMIT = 5;
export const CLIENT_ID_LOCAL_STORAGE_KEY = "refabric_pro_client_id";
export const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const MIN_WIDTH_HEIGHT_DEFAULT = 512; // Upload default
export const MIN_WIDTH_HEIGHT_REFERENCE_IMAGE = 512; // Reference Image
export const MIN_WIDTH_HEIGHT_PROMPT_ASSISTANT_MESSAGE = 0; // Prompt Assistant Message
export const MIN_WIDTH_HEIGHT_EDIT_FABRIC_AND_PRINT = 512; // Edit Fabric and Print
export const MIN_WIDTH_HEIGHT_REFERENCE_FABRIC = 512; // Reference Fabric
export const MIN_WIDTH_HEIGHT_REFERENCE_SKETCH = 0; // Reference Sketch
export const MIN_WIDTH_HEIGHT_ADD_LOGO = 0; // Add Logo
export const MIN_WIDTH_HEIGHT_MARKETPLACE_CONTENT = 0; // Marketplace Content
export const MIN_WIDTH_HEIGHT_TRYON_IMAGE_SELECT = 512; // Tryon Image Select
export const MIN_WIDTH_HEIGHT_PRODUCT_UPLOAD = 512; // Product Upload
export const MIN_WIDTH_HEIGHT_TRAINING = 1024; // Fabric Training, Model Training
export const MAX_UPLOAD_LIMIT_MB = Number(process.env.REACT_APP_UPLOAD_LIMIT) || 15;
export const MAX_UPLOAD_LIMIT_BYTES = MAX_UPLOAD_LIMIT_MB * 1024 * 1024;
export const VALID_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const VALID_IMAGE_ACCEPT = VALID_IMAGE_TYPES.join(",");
/** Documents the design agent's composer takes beside images (2026-10-22): a brief or a tech pack as a PDF. */
export const AGENT_DOCUMENT_TYPES = ["application/pdf"];
export const AGENT_UPLOAD_ACCEPT = [...VALID_IMAGE_TYPES, ...AGENT_DOCUMENT_TYPES].join(",");

// The MIME types a browser may report for a `.zip`. `application/octet-stream` is in the list
// because that is what several OS/browser combinations report for an archive, and leaving it
// out made valid ZIPs unselectable in the picker and "file type not accepted" on drop.
export const VALID_ZIP_TYPES = ["application/zip", "application/x-zip-compressed", "application/octet-stream"];
export const VALID_ZIP_ACCEPT = [...VALID_ZIP_TYPES, ".zip"].join(",");
// Video file extensions that must never be accepted as an image reference (generated
// videos live under app_cdn/videos/*.mp4 and would crash the BE's image-only pipelines).
export const VIDEO_FILE_EXTENSIONS = ["mp4", "mov", "webm", "m4v", "avi", "mkv", "ogv"];
// Browser-displayable still-image extensions. Used to filter crawled trend results
// (Pinterest 'orig' renditions can be .gif/.mp4/.heic — animated, video, or non-renderable).
export const WEB_SAFE_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp"];

export const MIN_WIDTH_GHOST_IMAGE = 512; // Ghost Image
export const MIN_HEIGHT_GHOST_IMAGE = 512; // Ghost Image
export const MIN_WIDTH_MANNEQUIN_IMAGE = 512; // Mannequin Image
export const MIN_HEIGHT_MANNEQUIN_IMAGE = 512; // Mannequin Image

export const DEFAULT_COLOR_HSL = {
  h: 0,
  s: 0,
  l: 0,
  a: 1,
};
